export default __webpack_public_path__ + "static/RecklessNeue-Regular-5035db049139cf7ced5fd9fdaf8e8ebe.woff2";